
export const getBanks = (state) => state.banks